import { RecalledValue } from "./RecalledValue";
import { RecallType } from "./RecallType";
import { VariablesState } from "../models/states/VariablesState";

export class SystemRecalledValue extends RecalledValue {
    variableName: string;
    variables: VariablesState;

    constructor(variableName: string, variables: VariablesState) {
        super();
        this.variableName = variableName;
        this.variables = variables;
    }

    evaluateProperty(
        mode: RecallType,
        property: string,
        parameters: string[],
    ): string | RecalledValue {
        switch (property) {
            case "code":
                return this.toCode();
            case "text":
                return this.toText();
        }
        return this;
    }

    toCode(): string {
        const variable = this.variables.system[this.variableName];
        return variable === undefined ? "0" : variable.code;
    }

    toText(): string {
        const variable = this.variables.system[this.variableName];
        return variable === undefined ? "" : variable.text;
    }
}
